<template>
  <div>
    <heading>{{ $t("sidebar.instructions") }}</heading>

    <div v-if="ready">
      <v-tabs v-model="activeTab" class="mb-4">
        <v-tab v-for="tab in availableTabs" :key="tab.key" :href="`#${tab.key}`">
          {{ $t(tab.label) }}
        </v-tab>
      </v-tabs>

      <!-- only the active tab is mounted: both tables use the same global
           table-pagination state and would fight over it if mounted together -->
      <div class="mt-2">
        <instructionFolderTable v-if="activeTab === 'instructions'" />
        <managedInstructionAssignmentsTable v-else-if="activeTab === 'managed'" />
      </div>
    </div>
  </div>
</template>

<script>
import instructionFolderTable from "@/views/instructions/instructionFolderTable.vue";
import { homePath } from "@/utils/access";
import managedInstructionAssignmentsTable from "@/views/managedInstruction/managedInstructionAssignmentsTable.vue";

//permission string -> tab
const TAB_DEFS = [
  {
    key: "managed",
    permission: "managedinstruction",
    label: "sidebar.onlineInstructions",
  },
  {
    key: "instructions",
    permission: "instruction",
    label: "sidebar.personalInstructions",
  },
];

export default {
  name: "instructionsHub",
  components: { instructionFolderTable, managedInstructionAssignmentsTable },
  data() {
    return {
      permissions: [],
      ready: false,
      activeTab: null,
    };
  },
  computed: {
    availableTabs() {
      return TAB_DEFS.filter((tab) =>
        this.permissions.includes(tab.permission),
      );
    },
  },
  async created() {
    const { permissions } = await this.$store.dispatch("getUserInfo");
    this.permissions = permissions || [];

    //no permission for either half: the nav hides the entry, but a direct URL
    //still lands here, so send them away
    if (!this.availableTabs.length) {
      this.$router.replace({ path: homePath() });
      return;
    }

    //keep the tab from the URL if it is one the user may see
    const requested = this.$route.query.tab;
    const allowed = this.availableTabs.some((tab) => tab.key === requested);
    this.activeTab = allowed ? requested : this.availableTabs[0].key;

    this.ready = true;
  },
  watch: {
    //remember the tab so a refresh or a drill-back returns to it
    activeTab(tab) {
      if (tab && this.$route.query.tab !== tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      }
    },
  },
};
</script>
